module.exports = __webpack_public_path__ + "img/4-3.48e7b6a0.jpg";